"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byIds = byIds;
exports.byDomains = byDomains;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var defaultQuery = (0, _immutable.fromJS)({
  id: [],
  ignoreDeletes: true,
  includeAllValues: true
});

var ensureList = function ensureList(list, name) {
  (0, _invariant.default)(_immutable.List.isList(list), "CompaniesAPIQuery: expected " + name + " to be a List but got %s", list);
};

function byIds(companyIds) {
  ensureList(companyIds, 'companyIds');
  return defaultQuery.merge({
    id: companyIds
  });
}

function byDomains(domains) {
  ensureList(domains, 'domains');
  return defaultQuery.merge({
    domain: domains
  });
}